(() => {
  const btnShowComments = $(".js-show-comments-btn");
  // Show label with counter comments
  const coluntReplys = () => {
    let dataHide = $(".replys-counter").data("hide");
    let dataShow = $(".replys-counter").data("show");
    let dataReply = $(".replys-counter").data("reply");
    let dataReplys = $(".replys-counter").data("replys");
    let replayWord;

    $("li.comment").each(function() {
      let self = $(this);

      // for translations in Loco plugin
      if (self.find(".reply")) {
        if (self.find(".children > li").length == 1) {
          replayWord = dataReply;
        } else {
          replayWord = dataReplys;
        }

        let div = '<div class="clearfix"></div>';

        self
          .find(".reply")
          .parent()
          .append(div);
      }

      if (self.find(".children")) {
        let count = self.children(".children").children("li").length;

        if (count == 1) {
          replayWord = dataReply;
        } else {
          replayWord = dataReplys;
        }

        let label =
          '<a rel="nofollow" class="comments-replys-label" href=""><span class="first">' +
          dataShow +
          "</span> " +
          count +
          " " +
          replayWord +
          "</a>";

        if (
          self.find(".comment-body").children(".comments-replys-label")
            .length == 0
        ) {
          self
            .children(".children")
            .prev()
            .append(label);
        }
      }
    });
    $(".comments-replys-label").on("click", function(event) {
      event.preventDefault();
      $(this).toggleClass("active");
      $(this)
        .parent()
        .next()
        .slideToggle();
      if ($(this).hasClass("active")) {
        $(this)
          .find(".first")
          .text(dataHide);
      } else {
        $(this)
          .find(".first")
          .text(dataShow);
      }
    });
  };

  // showMoreComments
  const showMoreComments = () => {
    const list = $(".comment-list");
    const allCommentsCount = list.find(".comment").length;
    const firstVisibleComments = list.find(".comment").slice(0, 3);
    let firstVisibleCommentsWithReplys = firstVisibleComments.find(".comment")
      .length;
    const displayComments = $(".display-comments-count");
    const hiddenComments = $(".hidden-comments-count");

    if (list.children().length > 3) {
      $(".more-comments-show").addClass("show");
      firstVisibleCommentsWithReplys == 0
        ? (firstVisibleCommentsWithReplys = 3)
        : (firstVisibleCommentsWithReplys += 3);
      hiddenComments.text(allCommentsCount - firstVisibleCommentsWithReplys);
    }

    $(".more-comments-show").on("click", function(event) {
      event.preventDefault();
      const hiddenCommentsCount = parseInt(hiddenComments.text());
      const displayCommentsCount = parseInt(displayComments.text());

      counter = displayCommentsCount + 3;
      list.find("li:nth-child(-n +" + counter + ")").slideDown("slow");

      $(this).removeClass("show");
    });
  };

  // Remove 'AT' from datetime in WordPress Comments
  const removeAtWord = () => {
    $("time").each(function() {
      let self = $(this);
      let str = self.text();
      let mySplitResult = str.split(" ");
      let lastWord = mySplitResult[mySplitResult.length - 2];
      let lastIndex = str.lastIndexOf(lastWord);

      str = str.substring(0, lastIndex);
      self.text(str);
    });
  };

  // Show Comments Form
  const showCommentsForm = event => {
    event.preventDefault();
    $(".js-hide-comments").show("slow");
  };

  // Add like
  const articleLikeLoad = postId => {
    $.ajax({
      type: "POST",
      url: ajaxurl,
      data: {
        action: "article_likes_load",
        postId: postId
      },

      success: function(data) {
        if (data != "") {
          $(".article-like__number").html(data);
        }
      },

      error: function(data, errorThrown) {
        $("#page").html(data);
        alert(errorThrown);
      }
    });
  };

  const articleLike = () => {
    if ($(".article-like").length > 0) {
      let myid = $(".article-like").attr("data-id");
      let dataDislike = $(".article-like__label").attr("data-dislike");
      let dataLIke = $(".article-like__label").text();
      let $like_ = "like-" + myid;

      articleLikeLoad(myid);
      if (localStorage.getItem("like" + myid, myid)) {
        $(".article-like").toggleClass("liked");
        $(".article-like__label").text(dataDislike);
      } else {
        $(".article-like").toggleClass("disliked");
      }

      $(".article-like").on("click", function() {
        // AJAX call goes to our endpoint url
        let num = $(".article-like__number").text();

        if (localStorage.getItem("like" + myid, myid)) {
          localStorage.removeItem("like" + myid, myid);
          $(".article-like").toggleClass("liked");
          $(".article-like").toggleClass("disliked");
          $(".article-like__label").text(dataLIke);
          $(".article-like__number").text(parseFloat(num) - 1);

          $.ajax({
            url: bloginfo.site_url + "/wp-json/tytan/v2/dislike/" + myid,
            type: "post",

            success: function() {
              console.log("Add dislike!");
            },
            error: function() {
              console.log("failed!");
            }
          });
        } else {
          localStorage.setItem("like" + myid, myid);
          $(".article-like").toggleClass("liked");
          $(".article-like").toggleClass("disliked");
          $(".article-like__label").text(dataDislike);
          $(".article-like__number").text(parseFloat(num) + 1);
          $.ajax({
            url: bloginfo.site_url + "/wp-json/tytan/v2/likes/" + myid,
            type: "post",
            success: function() {
              console.log("Add like");
            },
            error: function() {
              console.log("failed!");
            }
          });
        }
      });
    }
  };

  articleLike();

  $(document).ready(() => {
    removeAtWord();
    showMoreComments();
    coluntReplys();
    btnShowComments.on("click", function() {
      showCommentsForm(event);
    });
  });
})();
